
enum SessionState {
  IDLE = "idle",
  BUSY = "busy"
}

export default SessionState;

